import axios from "axios";
const back_url = process.env.REACT_APP_BACKEND_URL;
const token = localStorage.getItem("token");
const apiClient = axios.create({
  baseURL: back_url,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;

export const getIndividualTemplate = async (payload: any) => {
  try {
    const response = await apiClient.get(`/template/get/${payload}`, {
      responseType: "blob",
    });
    return response;
  } catch (error) {
    console.error("Error fetching reports:", error);
    return;
  }
};

export const getAllTemplates = async () => {
  try {
    const response = await apiClient.get(`/template/get-all`);
    return response.data;
  } catch (error) {
    console.error("Error fetching reports:", error);
    return;
  }
};
